import { listen } from './listen';
import { getNodes, noop } from './shared';
/**
 * Listens to the specified `type` of events and calls `onEvent` when one fires
 * outside all of the `targets`.
 * @param type Types of events to listen to.
 * @param target Nodes or RefObjects of nodes to listen on.
 * @param onEvent Function to call when one of the events fires.
 * @param options EventListener options.
 */
export function listenOutside(type, target, onEvent, options) {
    const nodes = getNodes(target);
    if (!onEvent || !nodes.length)
        return noop;
    const handler = (ev) => nodes.some((node) => node.contains(ev.target)) || onEvent(ev);
    const ownerDocument = nodes.map((n) => n.ownerDocument).find(Boolean);
    return listen(type, ownerDocument || document, handler, options);
}
//# sourceMappingURL=listenOutside.js.map